<div class="downloaded-file-container" #litmusdownladwidget [class.show]="isOpen">
    <div class="download-header">
        Processed Files
    </div>
    <div class="close-download-sidebar" (click)="closeSideBar()">
        X
    </div>
    <div class="downloaded-files-list">


        <div class="download-card" *ngFor="let item of downloadList">
            <div class="download-card-body">
                <img src="assets/images/files.svg" *ngIf="item.progress == 100"/>
                 <img class="loading-icon" src="assets/images/downloading.svg"  *ngIf="item.progress != 100"/>
                <div class="file-details">
                    <span class="file-name">{{item.filename}}</span> <span class="file-ext">.{{item.fileType}}</span>
                </div>
            </div>
            <div class="download-card-progress">
                <div class="progress" [ngStyle]="{width:item.progress+'%'}"></div>
            </div>
            <div class="download-card-footer">
                <button (click)="removeItem($event,item)">Remove</button>
                <button class="download-btn" [disabled]="item.progress != 100" (click)="downloadFile(item)">Download</button>
            </div>
        </div>
    </div>
</div>